var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "auth hero is-fullheight" }, [
      _c("div", { staticClass: "hero-body is-centered" }, [
        _c("div", { staticClass: "container is-centered" }, [
          _c("div", { staticClass: "sign-up-success" }, [
            _c(
              "h2",
              { staticClass: "title has-text-white has-text-centered" },
              [_vm._v("\n          Factura Timbrada\n        ")]
            ),
            _c(
              "p",
              { staticClass: "content has-text-white has-text-centered" },
              [
                _vm._v(
                  "\n          La factura se timbró correctamente.\n        "
                )
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }